<template>
  <VLayout
    :title="$t('userinformation.personal_data')"
  >
    <VAddressForm
      v-bind:a_uuid="aUuid"
      v-on:address-new-updated="doRedirect"
    />
    <VButtonGroup />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import VAddressForm from "@/components/AddressForm";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    VAddressForm,
    VButtonGroup,
  },
  data() {
    return {
      aUuid: this.$route.params.aUuid,
    };
  },
  methods: {
    doRedirect(data) {
      this.$router.push({
        name: "useraddress",
        props: { pt_uuid: data.pt_uuid },
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        userinformation: {
          personal_data: "New Address",
        },
      },
    },
  },
};
</script>
